"use strict";
/**
 * Shared response DTOs reused across more than one Financial endpoint
 * contract — mirrors each entity's real Prisma shape
 * (`prisma/schema.prisma`, frozen since Stage 5A/5C.1) as returned by
 * the certified Repository/Domain Service layers, hand-declared here
 * since this package does not import backend/Prisma source. Money
 * fields are `number` (integer paise, ADR-018) throughout, matching
 * every Financial Domain/Application Service's own convention —
 * never `string`/`Decimal`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHARGE_BILLING_SUMMARY_RESPONSE_EXAMPLE = exports.FIN_POSTING_EVENT_LOG_RESPONSE_EXAMPLE = exports.FIN_PACKAGE_RESPONSE_EXAMPLE = exports.FIN_TARIFF_RESPONSE_EXAMPLE = exports.FIN_ADVANCE_DEPOSIT_TRANSACTION_RESPONSE_EXAMPLE = exports.FIN_ADVANCE_DEPOSIT_ACCOUNT_RESPONSE_EXAMPLE = exports.FIN_RECEIPT_RESPONSE_EXAMPLE = exports.FIN_PAYMENT_RESPONSE_EXAMPLE = void 0;
exports.FIN_PAYMENT_RESPONSE_EXAMPLE = {
    id: '11111111-1111-1111-1111-111111111111',
    tenantId: '22222222-2222-2222-2222-222222222222',
    branchId: '33333333-3333-3333-3333-333333333333',
    patientId: '44444444-4444-4444-4444-444444444444',
    paymentNumber: 'PAY000001',
    transactionType: 'RECEIPT',
    totalAmount: 150000,
    status: 'COMPLETED',
    paymentDate: '2026-07-16T10:00:00.000Z',
    remarks: 'OPD consultation charge',
    version: 1,
    lockVersion: 2,
    createdAt: '2026-07-16T10:00:00.000Z',
    updatedAt: '2026-07-16T10:00:01.000Z',
};
exports.FIN_RECEIPT_RESPONSE_EXAMPLE = {
    id: '55555555-5555-5555-5555-555555555555',
    tenantId: '22222222-2222-2222-2222-222222222222',
    branchId: '33333333-3333-3333-3333-333333333333',
    paymentId: '11111111-1111-1111-1111-111111111111',
    receiptNumber: 'RCPT000001',
    status: 'ISSUED',
    cancelledAt: null,
    cancelledBy: null,
    reasonCode: null,
    reasonDescription: null,
    printCount: 0,
    refundPaymentId: null,
    version: 1,
    lockVersion: 1,
    createdAt: '2026-07-16T10:01:00.000Z',
    updatedAt: '2026-07-16T10:01:00.000Z',
};
exports.FIN_ADVANCE_DEPOSIT_ACCOUNT_RESPONSE_EXAMPLE = {
    id: '66666666-6666-6666-6666-666666666666',
    tenantId: '22222222-2222-2222-2222-222222222222',
    patientId: '44444444-4444-4444-4444-444444444444',
    accountType: 'IPD_DEPOSIT',
    payerId: null,
    balance: 500000,
    status: 'ACTIVE',
    version: 1,
    lockVersion: 3,
    createdAt: '2026-07-16T09:00:00.000Z',
    updatedAt: '2026-07-16T10:02:00.000Z',
};
exports.FIN_ADVANCE_DEPOSIT_TRANSACTION_RESPONSE_EXAMPLE = {
    id: '77777777-7777-7777-7777-777777777777',
    tenantId: '22222222-2222-2222-2222-222222222222',
    accountId: '66666666-6666-6666-6666-666666666666',
    paymentId: null,
    transactionType: 'CREDIT',
    amount: 100000,
    balanceAfter: 500000,
    remarks: 'Admission deposit',
    createdAt: '2026-07-16T10:02:00.000Z',
};
exports.FIN_TARIFF_RESPONSE_EXAMPLE = {
    id: '88888888-8888-8888-8888-888888888888',
    tenantId: '22222222-2222-2222-2222-222222222222',
    tariffCode: 'GEN-2026',
    name: 'General Tariff 2026',
    tariffType: 'GENERAL',
    payerId: null,
    branchId: '33333333-3333-3333-3333-333333333333',
    versionNumber: 1,
    status: 'ACTIVE',
    effectiveFrom: '2026-01-01T00:00:00.000Z',
    effectiveTo: null,
    version: 1,
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-07-16T10:03:00.000Z',
};
exports.FIN_PACKAGE_RESPONSE_EXAMPLE = {
    id: '99999999-9999-9999-9999-999999999999',
    tenantId: '22222222-2222-2222-2222-222222222222',
    packageCode: 'HC-BASIC',
    name: 'Basic Health Checkup',
    categoryId: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    basePrice: 250000,
    validityDays: 30,
    maxUsageCount: 1,
    branchId: null,
    versionNumber: 1,
    status: 'ACTIVE',
    effectiveFrom: '2026-01-01T00:00:00.000Z',
    effectiveTo: null,
    version: 1,
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-07-16T10:04:00.000Z',
};
exports.FIN_POSTING_EVENT_LOG_RESPONSE_EXAMPLE = {
    id: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    tenantId: '22222222-2222-2222-2222-222222222222',
    eventType: 'PAYMENT_RECEIVED',
    sourceEntityType: 'FinPayment',
    sourceEntityId: '11111111-1111-1111-1111-111111111111',
    postingRuleId: null,
    amount: 150000,
    occurredAt: '2026-07-16T10:01:05.000Z',
};
exports.CHARGE_BILLING_SUMMARY_RESPONSE_EXAMPLE = {
    chargeId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
    grossAmountPaise: 100000,
    discountAmountPaise: 5000,
    taxableAmountPaise: 95000,
    gst: { taxableAmount: 95000, cgst: 8550, sgst: 8550, igst: 0, totalTax: 17100, totalAmount: 112100 },
    netAmountPaise: 112100,
};
//# sourceMappingURL=financial-common.response.js.map